export default "__VITE_ASSET__7NN5nNYg__"